import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M21.75 10.993V3A1.76 1.76 0 0 0 20 1.25h-4A1.75 1.75 0 0 0 14.25 3v5.25H4.5a2.25 2.25 0 0 0-.205 4.49A5.84 5.84 0 0 0 8.1 17.51l-.52 2.07a1.75 1.75 0 0 0 1.7 2.17H17A1.76 1.76 0 0 0 18.75 20v-3.49a5.14 5.14 0 0 0 3-4.67v-.847M20 12.75H5.814a4.36 4.36 0 0 0 3.246 3.49h.12a.76.76 0 0 1 .55.91L9 19.94a.25.25 0 0 0 0 .21.24.24 0 0 0 .2.1H17a.25.25 0 0 0 .25-.25v-4a.75.75 0 0 1 .51-.71 3.63 3.63 0 0 0 2.377-2.546q-.069.006-.137.006m-5.75-1.5v-1.5H4.5a.75.75 0 0 0 0 1.5zm1.5 0V3a.25.25 0 0 1 .25-.25h4a.25.25 0 0 1 .25.25v8a.25.25 0 0 1-.25.25z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }